<script setup lang="ts">
import {useUxData} from "@/stores/ux-data.ts";
import {useCharacterDataStore} from "@/stores/character-data.ts";
import {onUpdated} from "vue";
import {useAppDataStore} from "@/stores/app-data.ts";

const store = useAppDataStore()
const swade = useCharacterDataStore()
const ux = useUxData()

onUpdated(() => {
  console.debug("SwadeBuildStats updated | ", swade.build)
})
</script>

<template>
  <div v-if="swade.build || store.character?.configuration" class="status-bar d-flex justify-content-md-center gap-lg-3 gap-2">
    <div class="attributes"
         data-bs-toggle="tooltip"
         :title="ux.labels.swade.tools.buildStatusIndicator.attributes"
         :class="(store.character?.configuration ?? swade.build).attributes?.overAllocated
            ? 'text-danger text-semibold'
            : ((store.character?.configuration ?? swade.build).attributes.unspentPoints ? 'text-warning' : '') "
    >
      <span class="fa-solid fa-exclamation-triangle" v-if="(store.character?.configuration ?? swade.build).attributes?.overAllocated || (store.character?.configuration ?? swade.build).attributes.unspentPoints"></span>
      <span class="fa-solid fa-check-circle" v-if="(store.character?.configuration ?? swade.build).attributes?.fullyAllocated"></span>
      <span class="label">
        <span class="d-sm-inline d-none">{{ ux.labels.swade.tools.buildStatusIndicator.attributes }}</span>
        <span class="d-sm-none d-inline fa-light fa-bicep"></span>
      </span>
      <span class="value">{{ (store.character?.configuration ?? swade.build).attributes?.allocated }}
      /
      {{ (store.character?.configuration ?? swade.build).attributes?.total }}</span>
    </div>
    <div class="skills"
         data-bs-toggle="tooltip"
         :title="ux.labels.swade.tools.buildStatusIndicator.traits"
         :class="(store.character?.configuration ?? swade.build).traits?.overAllocated
            ? 'text-danger text-semibold'
            : ((store.character?.configuration ?? swade.build).traits?.unspentPoints ? 'text-warning' : '')"
    >
      <span class="fa-solid fa-exclamation-triangle" v-if="(store.character?.configuration ?? swade.build).traits?.overAllocated || (store.character?.configuration ?? swade.build).traits?.unspentPoints"></span>
      <span class="fa-solid fa-check-circle" v-if="(store.character?.configuration ?? swade.build).traits?.fullyAllocated"></span>
      <span class="label">
        <span class="d-md-inline d-none">{{ ux.labels.swade.tools.buildStatusIndicator.traits }}</span>
        <span class="d-md-none d-inline fa-light fa-tools"></span>
      </span>
      <span class="value">{{ (store.character?.configuration ?? swade.build).traits?.allocated }}
      /
      {{ (store.character?.configuration ?? swade.build).traits?.total }}</span>
    </div>
    <div class="hindrances"
         data-bs-toggle="tooltip"
         :title="ux.labels.swade.tools.buildStatusIndicator.disadvantages"
         :class="(store.character?.configuration ?? swade.build).perkPoints?.overAllocated
            ? 'text-danger text-semibold'
            : ((store.character?.configuration ?? swade.build).perkPoints?.unspentPoints ? 'text-warning' : '')"
    >
      <span v-if="(store.character?.configuration ?? swade.build).perkPoints?.overAllocated || (store.character?.configuration ?? swade.build).perkPoints?.unspentPoints" class="fa-solid fa-exclamation-triangle"></span>
      <span v-if="(store.character?.configuration ?? swade.build).perkPoints?.fullyAllocated" class="fa-solid fa-check-circle"></span>
      <span class="label">
        <span class="d-md-inline d-none">{{ ux.labels.swade.tools.buildStatusIndicator.disadvantages }}</span>
        <span class="d-md-none d-inline fa-light fa-ban"></span>
      </span>
      <span class="value">{{ (store.character?.configuration ?? swade.build).perkPoints?.allocated }}
      /
      {{ (store.character?.configuration ?? swade.build).perkPoints?.total }}</span>
    </div>
    <div v-if="(store.character?.configuration ?? swade.build)?.languages" class="languages"
         data-bs-toggle="tooltip"
         :title="ux.labels.swade.tools.buildStatusIndicator.languages"
         :class="((store.character?.configuration ?? swade.build).languages?.overAllocated || ((store.character?.configuration ?? swade.build).languages?.allocated > (store.character?.configuration ?? swade.build).languages?.max))
           ? 'text-danger text-semibold'
           : ((store.character?.configuration ?? swade.build).languages?.unspentPoints ? 'text-warning' : '')"
    >
      <span v-if="(store.character?.configuration ?? swade.build).languages?.overAllocated || (store.character?.configuration ?? swade.build).languages?.unspentPoints || ((store.character?.configuration ?? swade.build).languages?.allocated > (store.character?.configuration ?? swade.build).languages?.max)" class="fa-solid fa-exclamation-triangle"></span>
      <span v-if="(store.character?.configuration ?? swade.build).languages?.fullyAllocated" class="fa-solid fa-check-circle"></span>
      <span class="label">
        <span class="d-md-inline d-none">{{ ux.labels.swade.tools.buildStatusIndicator.languages }}</span>
        <span class="d-md-none d-inline fa-light fa-language"></span>
      </span>
      <span class="value">{{ (store.character?.configuration ?? swade.build).languages?.allocated }}
      /
      {{ (store.character?.configuration ?? swade.build).languages?.total }}</span>
    </div>
    <div v-if="(store.character?.configuration?.other ?? swade.build.other)" class="other"
         data-bs-toggle="tooltip"
         :title="(store.character?.configuration?.other ?? swade.build.other)?.label"
         :class="(store.character?.configuration?.other ?? swade.build.other)?.overAllocated
         ? 'text-danger text-semibold'
         : ((store.character?.configuration?.other ?? swade.build.other)?.unspentPoints ? 'text-warning' : '')"
    >
      <span v-if="(store.character?.configuration?.other ?? swade.build.other)?.overAllocated || (store.character?.configuration?.other ?? swade.build.other)?.unspentPoints" class="fa-solid fa-exclamation-triangle"></span>
      <span v-if="(store.character?.configuration?.other ?? swade.build.other)?.fullyAllocated" class="fa-solid fa-check-circle"></span>
      <span class="label">
        {{ (store.character?.configuration?.other ?? swade.build.other)?.label ?? ux.labels.swade.data.superPowers.pointsAbbreviation }}
      </span>
      <span class="value">{{ (store.character?.configuration?.other ?? swade.build.other)?.allocated }}
      /
      {{ (store.character?.configuration?.other ?? swade.build.other)?.total }}</span>
    </div>
  </div>
</template>
